{
    "webshop_offer_voucher_correctCode": "输入的验证码正确",
    "webShop_howToFindId_desc": "你可以在玩家资料中找到并复制你的个人 ID",
    "webShop_howToFindId_link": "我的个人 ID 在哪里可以找到？",
    "webshop_offer_voucher_codeIsIncorrect": "代码不正确",
    "webshop_offer_voucher_enterYourCode": "输入您的代码",
    "webShop_unexpectedError_desc": "An unexpected error occurred, please try again later.",
    "webShop_accountBanned_desc": "Account banned!",
    "webshop_confirm": "确定",
    "mbs_access_welcome_desc": "Welcome, {0}",
    "btn_login": "Login",
    "mbs_access_error_sessionExpired_desc": "Your session has expired. Please enter your account ID manually."
}
